/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

$(document).ready(function() {
  $(function() {
    $('.datepicker').dateDropper();
    $('.timepicker').timeDropper({
      primaryColor: '#eb4f47',
      textColor: '#4a4a4a',
      borderColor: '#eb4f47',
      meridians: true
    });
  });

  $('#departure-time').timeDropper({
      primaryColor: '#eb4f47',
      textColor: '#4a4a4a',
      borderColor: '#eb4f47',
      meridians: true,
      callback: function (timeString) {
        var threeHoursEalier = moment(timeString, 'h:mm a').subtract('hours', 3).format('h:mm a');
        $('#pickup-time').val(threeHoursEalier);
      }
  });
});
